import { Component } from '@angular/core';

@Component({
    selector: 'page-body',
    templateUrl: './page-body.component.html'
})
export class PageBodyComponent {

}
